<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
        <div class="gray-dashed items-center">
            <label>發卡機構 </label>
            <div class="content w-full items-center flex">
                <span>{{ data?.cardBankName }}</span>
            </div>
        </div>
        <div class="gray-dashed items-center">
            <label>卡號</label>
            <div class="content">
                {{ data?.label }}
            </div>
        </div>
        <div class="gray-dashed items-baseline md:col-span-2">
            <label>有效月年</label>
            <div class="content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    }
};
</script>

<style scoped lang="scss">
.gray-dashed {
    @apply border-t border-dashed border-gray-200 pt-2.5 pb-2 flex min-h-[4rem];
    label {
        @apply flex-shrink-0 mr-4 text-sm xs:text-base text-gray-400 w-1/5 xs:w-1/4 md:w-1/3 md:w-[7rem] min-w-[5rem];
    }
    .content {
        @apply text-base xs:text-lg w-full;
    }
}
</style>
